import { createSelector } from 'reselect';

export const viewSelector = state => state.atg__view;

export const getCurrentView = createSelector(
  viewSelector,
  view => view.currentView,
);

export const hasViewToolbar = createSelector(
  viewSelector,
  view => view.hasToolbar,
);

export const getCurrentViewType = createSelector(
  viewSelector,
  view => view.viewType,
);

export const getToolbarContent = createSelector(
  viewSelector,
  view => view.currentView && view.currentView.getToolbarContent(),
);
